class ListChoice {
    /**
     * Toggle all choice
     * @param listChoice
     */
    static toggleAllChoice(listChoice) {
        const CHOICES        = listChoice.querySelectorAll('input');
        const DISABLE_CHOICE = listChoice.querySelector('#register_federation_0') || listChoice.querySelector('#profile_federation_0') || listChoice.querySelector('#contact_federation_0');

        if (DISABLE_CHOICE) {

            if (DISABLE_CHOICE.checked) {
                ListChoice.disable(CHOICES);
            }

            DISABLE_CHOICE.addEventListener('click', () => {
                if (DISABLE_CHOICE.checked) {
                    ListChoice.disable(CHOICES);
                } else {
                    ListChoice.enable(CHOICES)
                }
            })
        }
    }

    /**
     * Disable all choice
     * @param choices
     */
    static disable(choices) {
        for (let i = 0; i < choices.length; i++) {
            if (i !== 0) {
                choices[i].disabled = true;
                choices[i].checked  = false;
            }
        }
    }

    /**
     * Enable all choice
     * @param choices
     */
    static enable(choices) {
        for (let i = 0; i < choices.length; i++) {
            if (i !== 0) {
                choices[i].disabled = false;
            }
        }
    }
}